<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Budget Head</span>
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/budgetheads/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control"
                                v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod"
                                @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/BudgetHeads/MenuList.vue";
    import lang from "@/views/modules/BudgetHeads/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";
    import CustomSearch from "@/views/modules/BudgetHeads/SearchView.vue";
    export default {
        name: "new-budgetheads",
        components: {
            breadcrumbs,
            GenericList,
            CustomSearch,
        },
        data() {
            return {
                generic: true,
                isActive: false,
                metaList: [
                    {
                        label: lang.LBL_BUDGETHEAD_NAME,
                        link: true,
                        moduleName: 'BudgetHeads',
                        routePath: 'budgetheads',
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'name'

                    },
                    {
                        label: lang.LBL_BUDGETHEAD_SEQUENCE,
                        link: false,
                        moduleName: '',
                        routePath: '',
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'head_sequence'

                    },
                    {
                        label: lang.LBL_IS_MONTHLY,
                        link: false,
                        moduleName: '',
                        routePath: '',
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'is_monthly'

                    },
                    {
                        label: lang.LBL_STATUS,
                        link: false,
                        moduleName: '',
                        routePath: '',
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'status'

                    },

                ],
                columns: ['name', 'head_sequence', 'is_monthly', 'status'],
            }
        },
        mounted() {
            this.childMethod();
            let user = JSON.parse(localStorage.getItem('user_prefrence'));
            
        },
        methods: {
            childMethod(search = '') {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns, search);
                } else {
                    if (search != '') {
                        this.$refs.loadCustom.getProducts(search);
                    }
                }
            },
            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }
</script>